import { RandomId, StringHelper } from "@swivl-mono/helpers";
import { NodeData_Increment, NodeData_LeasePicker, NodeInterface, NodeType, VarKey } from "@swivl-mono/types";
import { Checkbox } from "@swivl-mono/ui";

import UserVariablesDropdown from "../../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import { TagInput } from "../../../../../Components/TagInput/TagInput";
import VarsModel from "../../../../../Models/Variables/VarsModel.Model";
import TabNodeLayoutData, { TabNodePositionalData } from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const LeasePickerNode = {
  Type: NodeType.LeasePicker,
  Empty: function () {
    return {
      id: RandomId(6),
      type: NodeType.LeasePicker,
      variableId: VarKey.UserLeaseId,
      initialMultipleLeasesMessage: "Please select your unit",
      shouldPickOnlyItemAutomatically: true,
      includeInactive: false,
      onPickedGoto: "",
      onlyItemAutomaticallyPickedGoto: "",
      noItemsGoto: "",
    } as NodeData_LeasePicker;
  },

  PlumbData: function (node: NodeInterface) {
    // const variable = (node.variableId && node.variableId.length) ? "#*" + node.variableId + "*#" : "Unset"
    // let title =  StringHelper.trimStringToLengthWithElipsis(VarsModel.replaceVariableNameInString(variable), 20)

    return TabNodeLayoutData({
      node: node,
      // label: node.amount > 0 ? "Increment" : "Decrement",
      title: "Lease Picker",
      // body: node.amount,
      titleHeight: 45,
      baseWidth: 150,
      tabs: node.shouldPickOnlyItemAutomatically
        ? [
          { title: "Lease Picked", id: "onPickedGoto", source: "onPickedGoto", target: node.onPickedGoto },
          { title: "No Leases", id: "noItemsGoto", source: "noItemsGoto", target: node.noItemsGoto },
          {
            title: "Only Lease Picked",
            id: "onlyItemAutomaticallyPickedGoto",
            source: "onlyItemAutomaticallyPickedGoto",
            target: node.onlyItemAutomaticallyPickedGoto,
          },
        ]
        : [
          { title: "Lease Picked", id: "onPickedGoto", source: "onPickedGoto", target: node.onPickedGoto },
          { title: "No Leases", id: "noItemsGoto", source: "noItemsGoto", target: node.noItemsGoto },
        ],
    });
  },

  InspectorPanel: class IncrementInspectorPanel extends NodePanel {
    // constructor(props) {
    //     super(props);

    // }

    render() {
      const node = this.props.node as NodeData_LeasePicker;

      return (
        <div>
          <div className="panel TableSaveRowPanel">
            <InspectorNodeHeader title="Lease Picker" id={node.id} />
            <label>Initial Multiple Lease Message</label>
            <TagInput
              key={"initialMultipleLeasesMessage" + this.props.node.id}
              value={this.props.node.initialMultipleLeasesMessage}
              onChange={this.onChange}
              name="initialMultipleLeasesMessage"
            />

            <label>Save Selected Lease To</label>
            <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name="variableId" value={node.variableId} skipBotVariables={true} />

            <Checkbox
              checked={node.shouldPickOnlyItemAutomatically}
              name={"shouldPickOnlyItemAutomatically"}
              onCheckedChange={(checked) => this.onChangeSwitch("shouldPickOnlyItemAutomatically", checked)}
              label="Automatically Pick if there is only one"
            />
            <Checkbox
              checked={node.includeInactive}
              name={"includeInactive"}
              onCheckedChange={(checked) => this.onChangeSwitch("includeInactive", checked)}
              label="Include Inactive Leases"
            />

            <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
          </div>
        </div>
      );
    }
  },
};
export default LeasePickerNode;
